import { Tagging } from '@empathy/search-types';
import { SearchState } from '../../../models';
import { SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchMutation } from '../search.interfaces';

export class SaveSearchResponseMutation implements SearchMutation {

  mutations = {
    [SEARCH_MUTATIONS_KEYS.saveSearchResponse]: (searchState: SearchState, searchResponse: Partial<SearchState>) => {
      if (searchState.keepPreviousResults) {
        searchState.results.push(...searchResponse.results ?? []);
        searchState.banners.push(...searchResponse.banners ?? []);
        searchState.promoteds.push(...searchResponse.promoteds ?? []);
        searchState.keepPreviousResults = false;
      } else {
        searchState.results = searchResponse.results ?? [];
        searchState.banners = searchResponse.banners ?? [];
        searchState.promoteds = searchResponse.promoteds ?? [];
      }
      searchState.facets = searchResponse.facets ?? {};
      searchState.partialResults = searchResponse.partialResults ?? [];
      searchState.queryTagging = searchResponse.queryTagging ?? {} as Tagging;
      searchState.directs = searchResponse.directs ?? [];
      searchState.spellcheck = searchResponse.spellcheck ?? '';
      searchState.numFound = searchResponse.numFound ?? 0;
    }
  };
}
